import { history } from '../store/index';
import {
    CLEAR_PROP_SUCCESS,
    CREATE_INVOICE_ENTRY_SUCCESS,
    FETCH_ACTIVITY_NO_SUCCESS,
    FETCH_FORM_DATA_SUCCESS,
    FETCH_INVOICE_ENTRY_SUCCESS,
    FETCH_QUOTE_SUCCESS,
    FIND_TPW_SUCCESS,
    GET_INVOICE_ENTRY_SUCCESS,
    SAVE_INVOICE_ENTRY_QUERY,
    STORE_TOTAL_DATA_FOR_INVOICE,
    STORE_TOTAL_DATA_FOR_LABOUR_INVOICE,
    STORE_TOTAL_DATA_FOR_SPARE_INVOICE,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess } from "./Common";
import { store } from "../../NextApp";
import { generateQueryString } from "../../util/Api";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_INVOICE_ENTRY_SUCCESS,
        data
    };
};

export const fetchFormDataSuccess = (data) => {
    return {
        type: FETCH_FORM_DATA_SUCCESS,
        data
    };
};

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_INVOICE_ENTRY_QUERY,
        query
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_INVOICE_ENTRY_SUCCESS,
        data
    };
};

export const clearProps = () => {
    return {
        type: CLEAR_PROP_SUCCESS,
    };
};

export const fetchQuotationsSuccess = ({ data, count }) => {
    return {
        type: FETCH_QUOTE_SUCCESS,
        data,
        count
    };
};

export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_INVOICE_ENTRY_SUCCESS,
        data,
        count
    };
};

export const fetchTpwResourceSuccess = (data) => {
    return {
        type: FIND_TPW_SUCCESS,
        data
    };
};

export const fetchActivityResourceSuccess = (data) => {
    return {
        type: FETCH_ACTIVITY_NO_SUCCESS,
        data
    };
};

export const setValueForTotalSpare = (data) => {
    return {
        type: STORE_TOTAL_DATA_FOR_SPARE_INVOICE,
        data
    };
};

export const setValueForTotal = (data) => {
    return {
        type: STORE_TOTAL_DATA_FOR_INVOICE,
        data
    };
};

export const setValueForTotalLabour = (data) => {
    return {
        type: STORE_TOTAL_DATA_FOR_LABOUR_INVOICE,
        data
    };
};

export const getResource = () => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { invoiceEntry } = store.getState();
            const { query } = invoiceEntry;
            const response = await axios.get(`/invoice-entry?${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            dispatch(getResourceSuccess(response.data));
        } catch (error) {
            // message.error(error.response.data.message);
            message.error("Record not found");
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getResourceForDownload = (columns, filters, name) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const { invoiceEntry } = store.getState();
            const { query } = invoiceEntry;
            const response = await axios.get(`/invoice-entry/download?columns=${columns}&${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            const str = arrayToCSV(response.data, filters, columns)
            downloadCSV(str, name);
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const fetchFormData = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());

        try {
            let formData = new FormData();
            const documentData = [];
            const documentIds = [];
            payload.documents && payload.documents.map((item, index) => {
                if (!item.file.path) {
                    formData.append('files', item.file);
                    let data = { ...item };
                    delete data.file;
                    documentData.push(data)
                } else {
                    documentIds.push(item._id);
                }
            });
            formData.append('documentData', JSON.stringify(documentData));
            formData.append('documentIds', JSON.stringify(documentIds));

            Object.keys(payload).forEach(key => {
                if (key === 'documents') {
                    return
                }
                if (key === 'spareRequired') {
                    formData.append(key, JSON.stringify(payload[key]));
                    return;
                }
                if (key === 'labourRequired') {
                    formData.append(key, JSON.stringify(payload[key]));
                    return;
                }
                if (key === 'activityNo') {
                    formData.append(key, JSON.stringify(payload[key]));
                    return;
                }
                if (payload[key] !== null) {
                    formData.append(key, payload[key]);
                }
            });

            const response = await axios.post(`/invoice-entry/modal`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            dispatch(fetchSuccess());
            dispatch(fetchFormDataSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const createResource = (payload, redirect = true, module) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            let formData = new FormData();
            const documentData = [];
            const documentIds = [];
            payload.documents && payload.documents.length && payload.documents.map((item, index) => {
                if (!item.file.path) {
                    formData.append('files', item.file);
                    let data = { ...item };
                    delete data.file;
                    documentData.push(data);
                } else {
                    documentIds.push(item._id);
                }
            });
            formData.append('documentData', JSON.stringify(documentData));
            formData.append('documentIds', JSON.stringify(documentIds));

            Object.keys(payload && payload.invoiceData).forEach(key => {
                if (key === 'documents') {
                    return
                }
                if (key === 'spareRequired') {
                    formData.append(key, JSON.stringify(payload.invoiceData[key]));
                    return;
                }
                if (key === 'labourRequired') {
                    formData.append(key, JSON.stringify(payload.invoiceData[key]));
                    return;
                }
                if (key === 'activityNo') {
                    formData.append(key, JSON.stringify(payload.invoiceData[key]));
                    return;
                }
                if (payload[key] !== null) {
                    formData.append(key, payload.invoiceData[key]);
                }
            });

            formData.append('spareData', JSON.stringify(payload.spareData));
            formData.append('labourData', JSON.stringify(payload.labourData));

            const response = await axios.post(`/invoice-entry`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            if (response && response.data && response.data.code === 202) {
                message.error(response && response.data.message)
                dispatch(fetchSuccess());
            } else {
                dispatch(createResourceSuccess(response.data));
                if (!redirect) {
                    dispatch(fetchFilter(module));
                } else {
                    history.push('/invoice-entry');
                    dispatch(getResource());
                }
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const updateResource = (payload, id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            let formData = new FormData();
            const documentData = [];
            const documentIds = [];
            payload.documents && payload.documents.map((item, index) => {
                if (!item.file.path) {
                    formData.append('files', item.file);
                    let data = { ...item };
                    delete data.file;
                    documentData.push(data);
                } else {
                    documentIds.push(item._id);
                }
            });
            formData.append('documentData', JSON.stringify(documentData));
            formData.append('documentIds', JSON.stringify(documentIds));

            Object.keys(payload).forEach(key => {
                if (key === 'documents') {
                    return
                }
                // if(key === 'spareRequired') {
                //   formData.append(key, JSON.stringify(payload.invoiceData[key]));
                //   return;
                // }
                // if(key === 'labourRequired') {
                //   formData.append(key, JSON.stringify(payload.invoiceData[key]));
                //   return;
                // }
                // if(key === 'activityNo') {
                //   formData.append(key, JSON.stringify(payload.invoiceData[key]));
                //   return;
                // }
                if (payload[key] !== null || payload[key] !== undefined) {
                    formData.append(key, payload[key]);
                }
            });
            // formData.append('spareData', JSON.stringify(payload.spareData));
            // formData.append('labourData', JSON.stringify(payload.labourData));

            await axios.put(`/invoice-entry/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            dispatch(fetchSuccess());
            // history.push('/invoice-entry');
            history.goBack();
            dispatch(getResource());
        } catch (error) {
            console.log("Error****:", error);
            dispatch(fetchError(error.response.data.message));
        }
    }
};

export const fetchResource = (id) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.get(`/invoice-entry/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const fetchTpwNo = (data) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        let query = '';
        Object.entries(data).forEach(([key, value], index) => {
            if (Object.keys(data).length - 1 === index) {
                query += `${key}=${value}`
            } else {
                query += `${key}=${value}&`
            }
        });
        try {
            const response = await axios.get(`/invoice-entry/tpw?${query}`);
            dispatch(fetchSuccess());
            dispatch(fetchTpwResourceSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

export const fetchQuotations = (data = '') => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            let payload = {
                tpwNo: data
            }
            const response = await axios.post(`/invoice-entry/quotations`, payload);
            dispatch(fetchSuccess());
            dispatch(fetchQuotationsSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    }
};

export const fetchActivitySno = (keyword) => {
    return async (dispatch) => {
        dispatch(fetchStart());

        try {
            // const response = await axios.get(`/invoice-entry/activity`);
            const response = await axios.get(`/invoice-entry/search-activity/${keyword.replaceAll('/', '~')}`);
            // const {data} = response;
            // console.log(data && data.length && data.map(d => d.activitySerialNo));
            dispatch(fetchSuccess());
            dispatch(fetchActivityResourceSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const deleteResource = (id) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.delete(`/invoice-entry/${id}`);
            if (response.data === false) {
                message.error('Record cannot be deleted, Found closed job cards !');
            } else {
                message.success('Record has been deleted successfully !');
            }
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data);
        }
    };
};

export const updateVendor = (id, payload, redirect = true, module) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {

            let formData = new FormData();
            const documentData = [];
            const documentIds = [];
            payload.documents && payload.documents.map((item, index) => {
                if (!item.file.path) {
                    formData.append('files', item.file);
                    let data = { ...item };
                    delete data.file;
                    documentData.push(data)
                } else {
                    documentIds.push(item._id);
                }
            });
            formData.append('documentData', JSON.stringify(documentData));
            formData.append('documentIds', JSON.stringify(documentIds));

            Object.keys(payload).forEach(key => {
                if (key === 'documents') {
                    return
                }
                if (payload[key] !== null) {
                    formData.append(key, payload[key]);
                }
            });

            const response = await axios.put(`/invoice-entry/vendor/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            if (response && response.data && response.data.code === 202) {
                message.error(response && response.data.message);
                dispatch(fetchSuccess());
            } else {
                if (response && response.data) {
                    message.success(`Vendor Updated!`);
                    dispatch(fetchSuccess());
                    // dispatch(fetchResourceSuccess({data: response.data}));
                    // history.replace(`/invoice-entry/edit/${id}`);
                    // dispatch(fetchResource(id));
                    setTimeout(() => {
                        window.location.reload(false);
                    }, 500);

                } else {
                    message.error('Vendor not updated!');
                    dispatch(fetchSuccess());
                }
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};
